<template>
	<div class="user-management-container">
		<SearchLabels
			:triggerSearchLabel="searchUsers"
			:setTextValue="setTextValue"
			:placeholder="`${$t('managementLabels.placeholder')}`"
		/>
		<div class="table-container">
			<table>
				<thead>
				<tr class="row">
					<th :class="['column', {'sticky-column' : index === 0}, {'unclickable': header.key === 'actions'}]" v-for="(header, index) in table?.headers"
							:key="index" @click="setNewOrder(header.key)">
						{{ $t(`${header.name}`) }}

						<img
							v-if="header.key === criteria.sort[0].by"
							:class="criteria.sort[0].order === 'ASC' ? 'rotated' : ''"
							src="@/drc/assets/icons/arrow-down-white.svg"
							alt="sort"
						>
					</th>
				</tr>
				</thead>
				<tbody>
				<tr class="row" v-for="(row, index) in table.rows" :key="index">
					<td
						v-for="(header, indexRow) in table.headers.filter(h => h.key !== 'actions')"
						:key="indexRow"
						:class="[
							'column',
							`column-${indexRow}`,
							{'sticky-column' : indexRow === 0},
							{'status-pending' : header.key === 'status' && row[header.key] === 'PENDING'},
							{'status-approved' : header.key === 'status' && row[header.key] === 'APPROVED'}
						]"
						v-html="`<div class='td-div'>${getText(row[header.key], header.key)}</div>`"
						@mouseover="hoverIn(index, indexRow)"
						@mouseout="hoverOut(index, indexRow)"
					>
					</td>
					<td>
						<div>
							<button class="approve" v-if="row['status'] === 'PENDING'" @click="approveUser(row)">
								{{$t('controlPanel.usersManagement.approve')}}
							</button>
							<button class="pending" v-else-if="row['status'] === 'APPROVED'" @click="setPending(row)">
								{{$t('controlPanel.usersManagement.setToPending')}}
							</button>
						</div>
						<div>
							<button class="halt" v-if="row['status'] === 'PENDING' || row['status'] === 'APPROVED'" @click="setHalted(row)">
								{{$t('controlPanel.usersManagement.setToHalted')}}
							</button>
							<button class="halt" v-else-if="row['status'] === 'HALTED'" @click="setUnhalted(row)">
								{{$t('controlPanel.usersManagement.setToUnhalted')}}
							</button>
						</div>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import SearchLabels from "@/drc/components/SearchLabels";
import {fetchUsers} from "@/common/services/common-graphql-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import {manageUser, sendEmail} from "@/common/services/common-request-service";

export default {
	name: "UsersManagement",
	components: {
		SearchLabels
	},
	data() {
		return {
			criteria: {
				text: null,
				pageable: {
					page: 0,
					size: 1000
				},
				sort: [
					{ by: "status", order: "DESC" },
					{ by: "createdDate", order: "DESC" }
				]
			},
			isLoading: false,
			table: {
				headers: [
					{key: 'id', name: 'controlPanel.usersManagement.form.id'},
					{key: 'fullName', name: 'controlPanel.usersManagement.form.fullName'},
					{key: 'email', name: 'controlPanel.usersManagement.form.email'},
					{key: 'company', name: 'controlPanel.usersManagement.form.company'},
					{key: 'jobTitle', name: 'controlPanel.usersManagement.form.jobTitle'},
					{key: 'createdDate', name: 'controlPanel.usersManagement.form.requestDate'},
					{key: 'lastLoginDate', name: 'controlPanel.usersManagement.form.lastLoginDate'},
					{key: 'status', name: 'controlPanel.usersManagement.form.status'},
					{key: 'actions', name: 'controlPanel.usersManagement.form.actions'}
				],
				rows: []
			}
		}
	},
	mounted() {
		this.$parent.$parent.$refs.mainContent.addEventListener("scroll", this.scrollHandler);
		this.searchUsers();
	},
	beforeDestroy() {
		this.$parent.$parent.$refs.mainContent.removeEventListener("scroll", this.scrollHandler);
	},
	methods: {
		setNewOrder(newOrderBy) {
			if(newOrderBy === 'actions'){
				return;
			}
			if(this.criteria.sort[0].by === newOrderBy){
				this.criteria.sort[0].order = this.criteria.sort[0].order === 'ASC' ? 'DESC' : 'ASC';
			}else{
				this.criteria.sort[0].by = newOrderBy;
				this.criteria.sort[0].order = 'ASC';
			}
			this.criteria.pageable.page = 0;
			this.searchUsers();
		},
		scrollHandler() {
			let currentPosition = this.$parent.$parent.$refs.mainContent.scrollTop;
			let bottom = this.$parent.$parent.$refs.mainContent.scrollHeight - window.innerHeight;
			if (currentPosition > bottom) {
				this.addScrollUsers();
			}
		},
		addScrollUsers() {
			this.criteria.pageable.page += 1
			this.searchUsers();
		},
		getText(text, key) {
			text = text ? text : '';

			if ((key === 'createdDate' || key === 'lastLoginDate') && text !== '') {
				const date = new Date(text);
				const options = { day: 'numeric', month: 'long', year: 'numeric' };
				text = date.toLocaleDateString('en-GB', options);
			}

			return text;
		},
		hoverIn(rowIndex, columnIndex) {
			let tds = document.getElementsByClassName(`column-${columnIndex}`);
			for (const td of tds) {
				td.classList.add('hovered')
			}
		},
		hoverOut(rowIndex, columnIndex) {
			let tds = document.getElementsByClassName(`column-${columnIndex}`);
			for (const td of tds) {
				td.classList.remove('hovered')
			}
		},
		searchUsers() {
			if (!this.isLoading) {
				this.isLoading = true;
				fetchUsers(this.criteria)
					.then((response) => {
						if (this.criteria.pageable.page === 0) {
							this.table.rows = response
						} else {
							this.table.rows.push(...response)
						}
					})
					.catch((error) => {
						console.error(error);
						this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
					})
					.finally(() => {
						this.isLoading = false;
					});
			}
		},
		setTextValue(text) {
			this.criteria.text = text;
			this.criteria.pageable.page = 0;
		},
		approveUser(user) {
			this.$dialog.openPopupModal({
				title: `${this.$t('controlPanel.usersManagement.popUp.areYouSureApprove')} ${user.fullName}`,
				onConfirm: () => {
					manageUser( {id: user.id, status: "APPROVED"}, "CHANGE_STATUS")
						.then(() => {
							user.status = "APPROVED";
							this.sendEmailForApprovedUser(user);
							this.showNotification(this.$i18n.t('controlPanel.usersManagement.successApprove'), NOTIFICATION_TYPE.SUCCESS);
						})
						.catch((error) => {
							this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
							console.error(error)
						})
				}
			})
		},
		setUnhalted(user) {
			manageUser( {id: user.id, status: "APPROVED"}, "CHANGE_STATUS")
				.then(() => {
					user.status = "APPROVED"
					this.showNotification(this.$i18n.t('controlPanel.usersManagement.successApprove'), NOTIFICATION_TYPE.SUCCESS);
				})
				.catch((error) => {
					this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
					console.error(error)
				})
		},
		setHalted(user) {
			this.$dialog.openPopupModal({
				title: ` ${user.fullName} ${this.$t('controlPanel.usersManagement.popUp.areYouSureSetPending')}`,
				onConfirm: () => {
					manageUser( {id: user.id, status: "HALTED"}, "CHANGE_STATUS")
						.then(() => {
							user.status = "HALTED"
							this.showNotification(this.$i18n.t('controlPanel.usersManagement.successHalted'), NOTIFICATION_TYPE.SUCCESS);
						})
						.catch((error) => {
							this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
							console.error(error)
						})
				}
			});
		},
		setPending(user) {
			this.$dialog.openPopupModal({
				title: ` ${user.fullName} ${this.$t('controlPanel.usersManagement.popUp.areYouSureSetPending')}`,
				onConfirm: () => {
					manageUser( {id: user.id, status: "PENDING"}, "CHANGE_STATUS")
						.then(() => {
							user.status = "PENDING"
							this.showNotification(this.$i18n.t('controlPanel.usersManagement.successPending'), NOTIFICATION_TYPE.SUCCESS);
						})
						.catch((error) => {
							this.showNotification(this.$i18n.t('formsNotifications.somethingWentWrong'), NOTIFICATION_TYPE.ERROR);
							console.error(error)
						})
				}
			});
		},
		sendEmailForApprovedUser(user) {
			const emailData = {
				to: {
					emails: [user.email]
				},
				title: 'Your DRC Guest Account now active',
				isDRC: true,
				message: `<div>
										Hello,</br></br>
										Your DRC Guest account has been successfully created. Now you may access the platform using your Guest account email and password.</br></br>
										<p style="color: #FDC030;"><b>Akkodis DRC Team</b></p>
									</div>`
			}
			sendEmail(emailData)
				.then()
				.catch((error) => {
					this.showNotification(this.$i18n.t('controlPanel.usersManagement.failedEmailToApprovedUser'), NOTIFICATION_TYPE.ERROR);
					console.error(error)
				})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.rotated {
	transform: rotate(180deg);
}

.user-management-container {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 50px;

	.table-container {
		width: 100%;
		height: 100%;
		position: relative;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

		table {
			width: 100%;
			height: 100%;
			border-collapse: collapse;
			font-family: Arial, sans-serif;
			position: relative;

			thead {
				position: sticky;
				top: 0;
				z-index: 2;
				border: 1px solid #747474;

				tr {
					th {
						cursor: pointer;
						min-height: 60px;
						font-weight: 500;
						padding: 15px 20px;
						background: #0D2A3D;
						border: 1px solid #747474;

						&.unclickable{
							cursor: default;
						}

						&.sticky-column {
							position: sticky;
							left: -1px;
							z-index: 3;

							&:after {
								content: "";
								width: 1px;
								height: 100%;
								border-right: 1px solid #747474;
								right: -1px;
								top: 0;
								position: absolute;
								display: inline-block;
								margin: 0;
							}
						}
					}
				}
			}

			tbody {
				tr {

					td {
						padding: 5px 10px;
						border: 1px solid #747474;
						background: #001f33;

						&.sticky-column {
							position: sticky;
							left: -1px;
							z-index: 1;

							&:after {
								content: "";
								width: 1px;
								height: 100%;
								border-right: 1px solid #747474;
								right: -1px;
								top: 0;
								position: absolute;
								display: inline-block;
								margin: 0;
							}
						}

						&.status-pending {
							color: #F7D049;
						}

						&.status-approved {
							color: $status-published
						}

						&.hovered {
							background: rgba(255, 255, 255, 0.20);
						}

						button {
							width: 100%;
							padding: 5px 10px;
							border: 1px solid white;
							cursor: pointer;
							text-transform: uppercase;
							background: transparent;
							color: white;
							border-radius: 4px;

							&:hover {
								border: 1px solid black;
								color: black;
								background: white;
							}
						}
					}

					&:hover {
						background: rgba(255, 255, 255, 0.3);

						td {
							background: rgba(255, 255, 255, 0.3);
						}
					}
				}
			}
		}
	}
}
</style>
